<div class="container-fluid" style="min-height: 500px;">
        <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 logout-body">
              <div class="row" style="margin-left: -7rem;">
                  <div class="col-md-1" style="margin-top: -15px;">
                      <i class="pi pi-exclamation-triangle"  style="color: green; font-size: 5.5rem;position: absolute;right: 385px;"></i>

                  </div>
                  <div class="col-md-10 text-left">
                      <h5>You have been logged out from this application.</h5>
                      <span style="text-decoration: underline"><a (click)="Login()" style="cursor:pointer;">Please Click Here to Re-login</a> </span>
                  </div>
              </div>
                </div>
              </div>

</div>
